import propertyTypesCodesReducer from "./propertyTypesCodesReducer";

export * from "./propertyTypesCodesReducer";

export default propertyTypesCodesReducer;
